export default (state, text = '') => ({
  action: 'chatSendTextFromClient',
  text,
  Timestamp: new Date().getTime(),
})
